import React from "react";
import { Flex, Box, Text } from "@chakra-ui/react"; // Added necessary Chakra imports
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const DefaultLayout = ({
  children,
  contentTop = "125px", // Default top margin
  contentBottom = "50px", // Default bottom margin
  title = "", // Optional title prop
  description = "", // Optional description prop
}) => {
  return (
    <Flex
      direction="column"
      overflow="hidden"
      mx={{ base: "10px", lg: "0px" }}
      minH="100vh"
    >
      {/* Background Section */}
      <Box
        position="absolute"
        minH={{ base: "60vh", md: "60vh" }}
        maxH={{ base: "60vh", md: "60vh" }}
        w="100vw"
        left="0"
        right="0"
        bgRepeat="no-repeat"
        overflow="hidden"
        zIndex="0"
        top="0"
        bgGradient="linear(to-b, brand.400, brand.600)"
      />

      {/* Navbar Section */}
      <Navbar />

      {/* Content Section */}
      <Flex
        direction="column"
        w="100%"
        p={{ base: "10px", md: "50px" }}
        maxW="100%"
        mx="auto"
        mt={contentTop}
        mb={contentBottom}
        zIndex="1"
      >
        {/* Title and Description (if provided) */}
        {title && description && (
          <Flex
            direction="column"
            textAlign="center"
            justifyContent="center"
            align="center"
            mt="10px"
            mb="30px"
          >
            <Text fontSize="4xl" color="white" fontWeight="bold">
              {title}
            </Text>
            <Text
              fontSize="md"
              color="white"
              fontWeight="normal"
              mt="10px"
              mb="26px"
              w={{ base: "90%", sm: "60%", lg: "40%", xl: "333px" }}
            >
              {description}
            </Text>
          </Flex>
        )}

        {/* Main Content */}
        {children}
      </Flex>

      {/* Footer Section */}
      <Footer />
    </Flex>
  );
};

export default DefaultLayout;
